import { Pagination, Dropdown, Typography } from '@sanlam-glacier/app-common/components';
import './table.styles.scss';
import { Block, Grid } from '@sanlam-glacier/app-common/modules/grid';

type TableFooterProps = {
  page: number;
  pageCount: number;
  pageSizeOptions?: Array<string>;
  defaultPageSize?: string;
  handlePageChange: (page: number) => void;
  handlePageSizeChange: (pageSize: string) => void;
  disabled?: boolean;
};

export const TableFooter = ({
  page,
  pageCount,
  pageSizeOptions,
  defaultPageSize,
  handlePageChange,
  handlePageSizeChange,
  disabled
}: TableFooterProps) => {
  return (
    <div className='table-footer'>
      <Grid row>
        <Block md={4} alignItems='center' justify='start' className='rows-per-page'>
          <Typography variant={Typography.VARIANT.B3}>Rows per page:&nbsp;</Typography>
          <Dropdown
            className='dropdown dropdown-v2 pagination-drop-down'
            disabled={disabled}
            inputVariant={Dropdown.VARIANT.TABLE}
            onChange={(item) => handlePageSizeChange(item as string)}
            items={pageSizeOptions ?? ['5', '10', '15', '20', '25', '50', '60']}
            maxHeight={200}
            selected={defaultPageSize ?? '10'}
            addOption={false}
          />
        </Block>
        <Block md={8} justify='end' alignItems='center'>
          <Pagination
            disabled={disabled}
            className='pagination'
            count={pageCount}
            fullWidth={false}
            page={page}
            onChange={(page: number) => handlePageChange(page)}
            maxVisibleItems={5}
          />
        </Block>
      </Grid>
    </div>
  );
};
